export class TableOfContents {
    content: HTMLElement;
    constructor(options = {}) {

        const defaults = {
            target: document,
            headers: 'h2, h3, h4, h5, h6',
            ulClass: 'mb-toc-list',
            liClass: 'mb-toc-item',
            containerClass: 'mb-toc-container',
            smoothScroll: true,
            scrollOffset: 0,
        };

        this.config = { ...defaults, ...options };

        this.init();
    }

    init() {
        const headers = this.config.target.querySelectorAll(this.config.headers);
        if (headers.length === 0) {
            return;
        }

        this.renderTOC(headers);
    }

    renderTOC(headers) {

        // Создаем список
        const tocList = document.createElement('ul');
        tocList.className = this.config.ulClass;
        this.content = tocList

        // Добавляем пункты оглавления
        headers.forEach(header => {
            this.createTOCItem(header, tocList);
        });
    }

    createTOCItem(header, parentList) {
        // Создаем ID, если его нет
        if (!header.id) {
            header.id = header.textContent
                .toLowerCase()
                .replace(/[^\wа-яё]+/gi, '-')
                .replace(/^-+|-+$/g, '');
        }

        // Создаем элемент списка
        const listItem = document.createElement('li');
        listItem.className = this.config.liClass;

        // Добавляем класс уровня заголовка
        const headerLevel = parseInt(header.tagName.substring(1));
        listItem.classList.add(`toc-level-${headerLevel}`);

        // Создаем ссылку
        const link = document.createElement('a');
        link.href = `#${header.id}`;
        link.textContent = header.textContent;

        // Настраиваем обработчик клика
        if (this.config.smoothScroll) {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                this.scrollToHeader(header);
            });
        }

        listItem.appendChild(link);
        parentList.appendChild(listItem);
    }

    scrollToHeader(header) {
        const elementPosition = header.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - this.config.scrollOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }

    renderTo(target) {
        let targetHTML = target = typeof this.config.container == "string" ? document.querySelector(target) : target;
        if (targetHTML) {
            targetHTML.innerHTML = '';
            targetHTML.classList.add(this.config.containerClass)
            targetHTML.appendChild(this.content);
        }
    }
}